const supportSticky = () => {
  const test = document.head.style;
  test.position = 'sticky';
  return test.position === 'sticky' ? true : false;
};
export default supportSticky;
